<section class="">
  <!-- Form -->
  <form [formGroup]="generateApiKeyForm" class="space-y-5">
    <!-- Institution Select -->
    <div>
      <label for="institutionSelect" class="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">
        Institution
        <span class="text-error">*</span>
      </label>

      @if (isLoadingInstitutions) {
      <div class="flex items-center justify-center py-8">
        <app-progress-loader></app-progress-loader>
      </div>
      } @else {
      <div class="relative">
        <select id="institutionSelect" formControlName="institutionId" class="w-full h-12 px-4 pr-10 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-gray-900 dark:text-white 
            focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-primary-500 dark:focus:border-primary-400
            disabled:bg-gray-100 dark:bg-slate-700 disabled:cursor-not-allowed
            appearance-none cursor-pointer transition-colors">
          <option value="" disabled selected class="text-gray-500 dark:text-slate-400">Select an institution...</option>
          @for (institution of institutions; track institution.id) {
          <option [value]="institution.id">{{ institution.name }}</option>
          }
        </select>

        <!-- Custom dropdown arrow -->
        <div class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
          <svg class="w-4 h-4 text-gray-500 dark:text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>
      </div>

      @if (generateApiKeyForm.get('institutionId')?.invalid && (generateApiKeyForm.get('institutionId')?.touched ||
      generateApiKeyForm.get('institutionId')?.dirty)) {
      <div class="text-error text-xs mt-2">Please select an institution.</div>
      }
      }
    </div>

    <!-- Product Select -->
    <div>
      <label for="productSelect" class="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">
        Product
        <span class="text-error">*</span>
      </label>

      @if (isLoadingProducts) {
      <div class="flex items-center justify-center py-8">
        <app-progress-loader></app-progress-loader>
      </div>
      } @else {
      <div class="relative">
        <select id="productSelect" formControlName="productId"
          [disabled]="!generateApiKeyForm.get('institutionId')?.value"
          class="w-full h-12 px-4 pr-10 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-gray-900 dark:text-white
            focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-primary-500 dark:focus:border-primary-400
            disabled:bg-gray-100 dark:disabled:bg-slate-700 disabled:cursor-not-allowed
            appearance-none cursor-pointer transition-colors">
          <option value="" disabled selected class="text-gray-500 dark:text-slate-400">
            {{ generateApiKeyForm.get('institutionId')?.value ? 'Select a product...' : 'Select an institution first...' }}
          </option>
          @for (product of products; track product.id) {
          <option [value]="product.id">{{ product.name }}</option>
          }
        </select>

        <!-- Custom dropdown arrow -->
        <div class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
          <svg class="w-4 h-4 text-gray-500 dark:text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </div>
      </div>

      @if (generateApiKeyForm.get('productId')?.invalid && (generateApiKeyForm.get('productId')?.touched ||
      generateApiKeyForm.get('productId')?.dirty)) {
      <div class="text-error text-xs mt-2">Please select a product.</div>
      }
      }
    </div>

    <!-- Allowed Origins -->
    <div>
      <label for="allowedOrigins" class="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">
        Allowed Origins
      </label>
      <textarea id="allowedOrigins" formControlName="allowedOrigins" rows="3"
        placeholder="203.0.113.5, 203.0.113.6"
        class="w-full px-4 py-3 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-gray-900 dark:text-white
          focus:outline-none focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:border-primary-500 dark:focus:border-primary-400
          transition-colors"></textarea>
      <div class="text-gray-500 dark:text-slate-400 text-xs mt-2">Comma-separated. Leave blank to allow none.</div>
    </div>

    <!-- Submit Button -->
    <div class="pt-4">
      <app-primary-button [text]="'Generate API Key'" [isLoading]="isLoading"
        (onClickEvent)="onSubmit()"></app-primary-button>
    </div>
  </form>
</section>